import { atom } from 'jotai'
import { TECredit } from '../types/ecredit.type'

export const eCreditState = atom<TECredit>({
    ushopCountryCode: '',
    baId: '',
    creditType: '',
    currency: '',
    availableBalance: 0,
    hydra: {
        log_id: null,
        duration: '',
        items: []
    }
})
